import React, {useState} from 'react';
import {Dialog, DialogContent, DialogTitle, Tooltip, Paper, Typography, IconButton} from "@mui/material";
import {IoAlertCircle, IoClose} from "react-icons/io5";
import "./ReturnCommentPopup.css";

const ReturnCommentPopup = ({file, roleId}) => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {file.returnComment && roleId !== "USER" && file.internal === false && (
                <div>
                    <Tooltip title={"დახარვეზების მიზეზი"}>
                        <div>
                            <IoAlertCircle onClick={handleClickOpen} className={"alert-icon-return_comment"}/>
                        </div>
                    </Tooltip>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="return-comment-dialog-title"
                        aria-describedby="return-comment-dialog-description"
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogTitle id="return-comment-dialog-title">
                            დახარვეზების მიზეზი
                            <IconButton
                                aria-label="close"
                                onClick={handleClose}
                                className="close-button"
                                style={{position: 'absolute', right: 8, top: 8}}
                            >
                                <IoClose/>
                            </IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Paper style={{padding: '16px', maxHeight: '60vh', overflow: 'auto'}}>
                                <Typography variant="body1">
                                    {file.returnComment}
                                </Typography>
                            </Paper>
                        </DialogContent>

                    </Dialog>
                </div>
            )}
        </>
    );
};

export default ReturnCommentPopup;
